import { Link } from "@tanstack/react-router";
import { CloudUpload, TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUploadQueue } from "@/hooks/use-upload-queue";
import { staleLabel, waitingLabel } from "@/lib/capture";
import { cn } from "@/lib/utils";

/**
 * How many photos are still on this phone, with a way to the queue. Hidden when nothing waits;
 * a warning once any has been waiting long enough that the crew should find signal before leaving.
 */
export function QueueBanner({ link = true }: { link?: boolean }) {
  const { summary } = useUploadQueue();
  const waiting = summary.waiting + summary.sending;
  if (waiting === 0) return null;
  const stale = summary.stale > 0 && summary.oldestWaitingAt !== null;

  return (
    <div
      role="status"
      data-testid="queue-banner"
      className={cn(
        "flex items-start gap-3 rounded-lg border p-3",
        stale
          ? "border-[var(--warning)]/40 bg-[var(--warning-bg)] text-[var(--warning)] dark:bg-amber-500/15 dark:text-amber-300"
          : "bg-card",
      )}
    >
      {stale ? (
        <TriangleAlert className="mt-0.5 size-5 shrink-0" />
      ) : (
        <CloudUpload className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
      )}
      <p className="min-w-0 flex-1 text-sm">
        {stale && summary.oldestWaitingAt !== null
          ? staleLabel(summary.stale, summary.oldestWaitingAt)
          : waitingLabel(waiting)}
      </p>
      {link && (
        <Button asChild variant="outline" size="sm" className="shrink-0">
          <Link to="/capture/queue">View</Link>
        </Button>
      )}
    </div>
  );
}
